import axios from 'axios';
// import router from '@router/_bootstrap';
import { TOKEN_NAME, REFRESH_TOKEN_NAME } from '@constants/token';
import {
    API_BASE_URL,
    AUTH_TOKEN_ENDPOINT,
    AUTH_TOKEN_REFRESH_ENDPOINT,
} from '@constants/api';
import cookieHandler from '@websanova/vue-auth/src/lib/cookie';
import tokenHandler from '@websanova/vue-auth/src/lib/token';

const configuration = {
    options: {
        tokenDefaultName: TOKEN_NAME,
        tokenStore: ['localStorage', 'cookie'],
        cookieDomain: () => window.location.hostname,
    },
};

class Response {
    constructor () {
        this.isRefreshing = false;
        this.subscribers = [];
        this.blacklist = [
            `${API_BASE_URL}${AUTH_TOKEN_ENDPOINT}`,
            `${API_BASE_URL}${AUTH_TOKEN_REFRESH_ENDPOINT}`,
        ];
    }

    addInterceptor () {
        // Only allow one listener to be set for the authentication response intercept
        if (this.hasInterceptor()) {
            return;
        }

        this.responseIntercept = axios.interceptors.response.use(
            response => response,
            error => {
                const request = error.config;

                // Reject promise if the error status is not 401
                if (
                    !error.response
                    || (error.response.status && Number(error.response.status) !== 401)
                    || this.blacklist.includes(request.url)
                ) {
                    return Promise.reject(error);
                }

                if (!this.isRefreshing) {
                    this.isRefreshing = true;
                    const refreshToken = window.localStorage.getItem(REFRESH_TOKEN_NAME);

                    if (!refreshToken) {
                        tokenHandler.remove.call(configuration, TOKEN_NAME);
                        tokenHandler.remove.call(configuration, REFRESH_TOKEN_NAME);

                        // TO-DO: Add back logout routes on auth only routes
                        // return router.push('/logout');
                    }

                    axios
                        .post(AUTH_TOKEN_REFRESH_ENDPOINT, {
                            refreshToken,
                        })
                        .then(({ data: { token, refreshToken } }) => {
                            tokenHandler.set.call(configuration, TOKEN_NAME, token);
                            tokenHandler.set.call(configuration, REFRESH_TOKEN_NAME, refreshToken);

                            cookieHandler.set.call(configuration, 'rememberMe', true);

                            this.queueHandler(token);
                        })
                        .catch(error => {
                            if (error.response.status === 401) {
                                tokenHandler.remove.call(configuration, TOKEN_NAME);
                                tokenHandler.remove.call(configuration, REFRESH_TOKEN_NAME);
                                // TO-DO: Add back logout routes on auth only routes
                                // return router.push('/logout');
                            }

                            throw error;
                        })
                        .finally(() => {
                            this.isRefreshing = false;
                            this.subscribers = [];
                        });
                }

                return new Promise(resolve => {
                    this.subscribe(token => {
                        request.headers.Authorization = `Bearer ${token}`;

                        resolve(axios(request));
                    });
                });
            }
        );
    }

    subscribe (callback) {
        this.subscribers.push(callback);
    }

    queueHandler (token) {
        this.subscribers.map(callback => callback(token));
    }

    hasInterceptor () {
        return Boolean(this.requestIntercept);
    }

    clearInterceptor () {
        axios.interceptors.response.eject(this.responseIntercept);

        this.responseIntercept = null;
    }

    resetInterceptor () {
        this.clearInterceptor();
        this.addInterceptor();
    }
}

// Export singleton
export default new Response();
